import React from 'react'
import { ConnectedRouter } from 'react-router-redux'

import history from 'src/history.js'

const AppRouter = ({ children }) => <ConnectedRouter history={history}>{children}</ConnectedRouter>

export default AppRouter
